module.exports = __webpack_public_path__ + "img/hotel-vila-gale-opera.77afa7e4.jpg";